<template>
  <v-container fluid class="pa-4">
    <carga v-if="cargar" />
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />

    <v-card class="shadowCard mb-4 mapa-kpi-filtros" elevation="0">
      <v-card-title class="py-3 d-flex align-center flex-wrap">
        <v-icon left color="primary">mdi-map-marker-radius</v-icon>
        Mapa Sucursales
        <v-spacer />
        <v-btn small tile color="primary" class="mr-2" :loading="syncing" @click="sincronizar">
          Sincronizar
        </v-btn>
        <v-btn small tile outlined color="secondary" @click="abrirNuevoPunto">
          Agregar ubicación
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="filtroCiudad"
              :items="opcionesCiudad"
              label="Ciudad"
              filled
              dense
              hide-details
              clearable
              :menu-props="menuPropsSelect"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="filtroEscuela"
              :items="opcionesEscuela"
              item-text="nombre"
              item-value="escuela"
              label="Escuela"
              filled
              dense
              hide-details
              clearable
              :menu-props="menuPropsSelect"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="filtroTipo"
              :items="opcionesTipo"
              item-text="nombre"
              item-value="tipo"
              label="Tipo"
              filled
              dense
              hide-details
              clearable
              :menu-props="menuPropsSelect"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="tipoOrigen"
              :items="opcionesOrigenVisibles"
              item-text="nombre"
              item-value="value"
              label="Origen traslado"
              filled
              dense
              hide-details
              :menu-props="menuPropsSelect"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2" v-if="tipoOrigen === 'sucursal'">
            <v-autocomplete
              v-model="origenPlantelId"
              :items="puntosConCoords"
              item-text="nombre"
              item-value="id_referencia"
              label="Sucursal origen"
              filled
              dense
              hide-details
              :menu-props="menuPropsSelect"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2" class="d-flex align-center flex-wrap">
            <v-btn
              v-if="tipoOrigen === 'usuario'"
              small
              tile
              color="secondary"
              class="mr-1 mb-1"
              :loading="geoLoading"
              @click="obtenerMiUbicacion"
            >
              Usar GPS
            </v-btn>
            <v-btn
              v-if="tipoOrigen === 'usuario'"
              small
              tile
              outlined
              color="secondary"
              class="mb-1"
              :disabled="geoLoading"
              @click="activarMarcarOrigen"
            >
              {{ marcarOrigenActivo ? 'Click en mapa…' : 'Marcar en mapa' }}
            </v-btn>
            <v-alert
              v-if="tipoOrigen === 'usuario' && origenLat == null"
              type="warning"
              dense
              text
              class="mapa-origen-alerta-compacta mt-2 mb-0"
            >
              Define tu origen con GPS o marcándolo en el mapa.
            </v-alert>
          </v-col>
        </v-row>
        <v-checkbox
          v-model="mostrarInactivos"
          label="Mostrar ubicaciones desactivadas"
          dense
          hide-details
          class="mt-2 mb-0"
        />
        <v-btn
          small
          outlined
          tile
          :color="mostrarTeachers ? 'deep-purple' : 'grey darken-1'"
          class="mt-2"
          @click="mostrarTeachers = !mostrarTeachers"
        >
          <v-icon left small>{{ mostrarTeachers ? 'mdi-account-group' : 'mdi-account-off' }}</v-icon>
          {{ mostrarTeachers ? 'Ocultar teachers' : 'Mostrar teachers' }}
        </v-btn>
        <v-btn
          v-if="puntosSinCoords.length"
          small
          text
          color="info"
          class="mt-2 px-0"
          @click="sinCoordsDialog = true"
        >
          <v-icon left small>mdi-map-marker-question</v-icon>
          Corregir {{ puntosSinCoords.length }} ubicación(es) sin coordenadas
        </v-btn>
        <v-alert
          v-if="tipoOrigen === 'usuario' && origenLat != null"
          :type="origenFuente === 'ip' ? 'warning' : 'success'"
          outlined
          prominent
          class="mapa-origen-alerta mt-3 mb-0"
        >
          <div class="font-weight-bold">
            <v-icon left :color="origenFuente === 'ip' ? 'orange darken-2' : 'green darken-2'">
              {{ origenFuente === 'ip' ? 'mdi-map-marker-alert' : 'mdi-crosshairs-gps' }}
            </v-icon>
            {{ origenFuente === 'ip' ? 'Ubicación aproximada' : 'Ubicación actual detectada' }}
          </div>
          <div class="body-2">
            {{ origenLat.toFixed(5) }}, {{ origenLng.toFixed(5) }}
            <span v-if="origenEtiqueta"> · {{ origenEtiqueta }}</span>
          </div>
          <div v-if="origenFuente === 'ip'" class="caption font-weight-medium">
            La ruta puede ser incorrecta; usa GPS o marca tu punto en el mapa.
          </div>
        </v-alert>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col cols="12" md="8">
        <v-card class="shadowCard mapa-kpi-card" elevation="0">
          <div ref="mapEl" class="mapa-kpi">
            <div v-if="!mapLoadError" class="mapa-leyenda">
              <span><i class="mapa-leyenda-punto mapa-leyenda-punto--inbi"></i> INBI</span>
              <span><i class="mapa-leyenda-punto mapa-leyenda-punto--fast"></i> FAST</span>
              <span><i class="mapa-leyenda-punto mapa-leyenda-punto--teacher"></i> Teacher</span>
              <span><i class="mapa-leyenda-punto mapa-leyenda-punto--custom"></i> Otra</span>
              <span><i class="mapa-leyenda-punto mapa-leyenda-punto--origen"></i> Tu ubicación</span>
            </div>
            <div v-if="mapLoadError" class="mapa-kpi-error">
              {{ mapLoadError }}
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card v-if="seleccionado" class="shadowCard mb-4" elevation="0">
          <v-card-title class="py-2 text-subtitle-1">
            {{ seleccionado.nombre }}
            <v-chip x-small class="ml-2" :color="colorPunto(seleccionado)" dark>
              {{ etiquetaTipoPunto(seleccionado) }}
            </v-chip>
            <v-chip v-if="Number(seleccionado.activo) === 0" x-small class="ml-1" color="grey" dark>
              Inactiva
            </v-chip>
            <v-spacer />
            <v-btn small text color="primary" title="Editar ubicación" @click="abrirEditarPunto">
              <v-icon left small>mdi-pencil</v-icon>
              Editar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="caption mb-2">{{ seleccionado.direccion || 'Sin dirección' }}</div>
            <v-alert v-if="seleccionado.nota" dense outlined color="amber darken-2" class="mb-2">
              <div class="font-weight-bold caption">Nota operativa</div>
              <div class="caption nota-operativa-text">{{ seleccionado.nota }}</div>
            </v-alert>
            <div class="caption mb-1"><b>Ciudad:</b> {{ seleccionado.ciudad || '—' }}</div>
            <div v-if="seleccionado.tipo === 'teacher'" class="caption mb-2">
              <b>Sucursal más cercana:</b>
              <span v-if="sucursalCercana">
                {{ sucursalCercana.nombre }} · {{ sucursalCercana.distanciaKm.toFixed(1) }} km
              </span>
              <span v-else>no disponible, falta ubicar el domicilio</span>
            </div>
            <v-autocomplete
              v-if="seleccionado.tipo === 'teacher' && sucursalesRuta.length"
              v-model="sucursalRutaId"
              :items="sucursalesRuta"
              item-text="nombreRuta"
              item-value="id"
              label="Sucursal destino de la ruta"
              filled
              dense
              hide-details
              class="mb-2"
              :menu-props="menuPropsSelect"
            />
            <div v-if="seleccionado.latitud != null" class="caption mb-1 grey--text">
              {{ seleccionado.latitud }}, {{ seleccionado.longitud }}
              <span v-if="seleccionado.geo_fuente"> · {{ etiquetaGeoFuente(seleccionado.geo_fuente) }}</span>
            </div>
            <div v-if="seleccionado.tipo === 'teacher' && sucursalDestinoRuta" class="caption grey--text mb-1">
              Ruta: domicilio del teacher → {{ sucursalDestinoRuta.nombre }}.
            </div>

            <div v-if="rutaLoading" class="my-2 caption">Calculando tiempos…</div>
            <div v-else-if="rutaInfo" class="my-2">
              <div v-if="origenCoordsStr && destinoCoordsStr" class="d-flex align-center mb-2">
                <span class="caption font-weight-medium mr-2">Modo:</span>
                <v-btn-toggle v-model="modoRutaEmbed" dense mandatory class="mapa-ruta-modos">
                  <v-btn value="driving" x-small>Auto</v-btn>
                  <v-btn value="transit" x-small>Transporte</v-btn>
                </v-btn-toggle>
              </div>
              <div
                v-if="modoRutaEmbed === 'driving' && rutaInfo.driving && rutaInfo.driving.duracion_texto"
                class="body-2"
              >
                <v-icon x-small>mdi-car</v-icon>
                Auto: {{ rutaInfo.driving.duracion_texto }}
                <span class="caption grey--text">({{ etiquetaProveedorRuta(rutaInfo.driving) }})</span>
              </div>
              <div
                v-if="modoRutaEmbed === 'driving' && rutaInfo.driving && rutaInfo.driving.sin_trafico"
                class="caption grey--text mb-1"
              >
                Estimado sin tráfico en vivo — el mapa de Google abajo puede mostrar más tiempo según el tráfico actual.
              </div>
              <div
                v-if="modoRutaEmbed === 'transit' && rutaInfo.transit && rutaInfo.transit.duracion_texto"
                class="body-2"
              >
                <v-icon x-small>mdi-bus</v-icon>
                Transporte público: {{ rutaInfo.transit.duracion_texto }}
                <span class="caption grey--text">({{ etiquetaProveedorRuta(rutaInfo.transit) }})</span>
              </div>
              <div
                v-if="modoRutaEmbed === 'transit' && rutaInfo.transit && rutaInfo.transit.instrucciones && rutaInfo.transit.instrucciones.length"
                class="ruta-transit-detalle mt-2"
              >
                <div class="caption font-weight-bold mb-1">Cómo llegar:</div>
                <div
                  v-for="(paso, pasoIdx) in rutaInfo.transit.instrucciones"
                  :key="'paso-transit-' + pasoIdx"
                  class="caption ruta-transit-paso"
                >
                  <v-icon x-small class="mr-1">
                    {{ paso.tipo === 'transit' ? 'mdi-bus' : 'mdi-walk' }}
                  </v-icon>
                  {{ paso.texto }}
                </div>
              </div>
              <div
                v-else-if="modoRutaEmbed === 'transit' && rutaInfo.transit && rutaInfo.transit.mensaje"
                class="caption orange--text"
              >
                {{ rutaInfo.transit.mensaje }}
              </div>
            </div>

            <v-textarea
              v-model="notaEdit"
              label="Nota operativa"
              filled
              dense
              hide-details
              rows="3"
              class="mt-2"
            />
            <v-btn small tile color="primary" class="mt-2" :loading="notaSaving" @click="guardarNota">
              Guardar nota
            </v-btn>
            <v-btn
              v-if="Number(seleccionado.activo) !== 0"
              small
              tile
              text
              color="error"
              class="mt-2 ml-2"
              @click="desactivarSeleccionado"
            >
              Desactivar
            </v-btn>
            <v-btn
              v-else
              small
              tile
              color="success"
              class="mt-2 ml-2"
              @click="activarSeleccionado"
            >
              Activar
            </v-btn>
          </v-card-text>
        </v-card>

        <v-card class="shadowCard" elevation="0">
          <v-card-title class="py-2 text-subtitle-1">
            <v-icon left small>mdi-robot</v-icon>
            Asistente
          </v-card-title>
          <v-card-text>
            <div class="asistente-chat mb-2">
              <div
                v-for="(m, idx) in chatMensajes"
                :key="idx"
                class="asistente-burbuja"
                :class="m.rol === 'user' ? 'asistente-burbuja--user' : 'asistente-burbuja--ia'"
              >
                {{ m.texto }}
              </div>
              <div v-if="!chatMensajes.length" class="caption grey--text">
                Sugerencia: selecciona un teacher para ver su domicilio y pedir la ruta a una sucursal.
              </div>
            </div>
            <v-textarea
              v-model="chatInput"
              label="Escribe tu pedido"
              filled
              dense
              hide-details
              rows="2"
              @keydown.enter.exact.prevent="enviarAsistente"
            />
            <v-btn
              small
              tile
              color="primary"
              class="mt-2"
              :loading="chatLoading"
              :disabled="!chatInput"
              @click="enviarAsistente"
            >
              Enviar
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="sinCoordsDialog" max-width="430">
      <v-card>
        <v-card-title class="text-subtitle-1">
          Corregir ubicación
          <v-spacer />
          <v-btn icon small @click="sinCoordsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="caption mb-2">
            Estas ubicaciones llegaron del ERP sin coordenadas. Selecciona una para capturar su dirección y ubicación en el mapa.
          </div>
          <v-autocomplete
            v-model="puntoSinCoordsId"
            :items="puntosSinCoords"
            item-text="nombre"
            item-value="id"
            label="Ubicación sin coordenadas"
            filled
            dense
            hide-details
            :menu-props="menuPropsSelect"
            @change="seleccionarPuntoSinCoords"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editorDialog" max-width="650">
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ editorEsNuevo ? 'Agregar ubicación' : 'Editar ubicación' }}
          <v-spacer />
          <v-btn icon small @click="cerrarEditorPunto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="editorForm.nombre"
                label="Nombre"
                filled
                dense
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="editorForm.tipo"
                :items="opcionesTipoEdicion"
                item-text="nombre"
                item-value="tipo"
                label="Tipo"
                filled
                dense
                hide-details="auto"
                :disabled="!editorEsNuevo"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="editorForm.ciudad"
                :items="opcionesCiudad"
                label="Ciudad"
                filled
                dense
                clearable
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="editorForm.escuela"
                :items="opcionesEscuela"
                item-text="nombre"
                item-value="escuela"
                label="Escuela"
                filled
                dense
                clearable
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="editorForm.direccion"
                label="Dirección"
                filled
                dense
                rows="2"
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="editorForm.latitud"
                label="Latitud"
                type="number"
                step="0.0000001"
                filled
                dense
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="editorForm.longitud"
                label="Longitud"
                type="number"
                step="0.0000001"
                filled
                dense
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-btn small outlined color="secondary" class="mt-2" @click="activarSeleccionCoordenadaEditor">
            {{ editorPickActive ? 'Haz clic en Google Maps…' : 'Elegir coordenadas en el mapa' }}
          </v-btn>
          <div v-if="editorPickActive" class="caption orange--text mt-2">
            Haz clic en el mapa grande para colocar esta ubicación.
          </div>
          <v-checkbox
            v-if="!editorEsNuevo"
            v-model="editorForm.activo"
            label="Ubicación activa"
            dense
            hide-details
            class="mt-2"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text small @click="cerrarEditorPunto">Cancelar</v-btn>
          <v-btn small tile color="primary" :loading="editorSaving" @click="guardarPunto">
            Guardar ubicación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

let googleMapsScriptPromise = null

function cargarGoogleMapsScript (apiKey) {
  if (typeof window === 'undefined') return Promise.reject(new Error('Google Maps requiere navegador'))
  if (window.google && window.google.maps) return Promise.resolve(window.google.maps)
  if (googleMapsScriptPromise) return googleMapsScriptPromise

  googleMapsScriptPromise = new Promise((resolve, reject) => {
    const callbackName = '__rhGoogleMapsReady_' + Date.now()
    const script = document.createElement('script')
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) +
      '&callback=' + callbackName + '&language=es&region=MX'
    script.async = true
    script.defer = true
    window[callbackName] = () => {
      delete window[callbackName]
      resolve(window.google.maps)
    }
    script.onerror = () => {
      delete window[callbackName]
      googleMapsScriptPromise = null
      reject(new Error('No se pudo cargar Google Maps JavaScript API'))
    }
    document.head.appendChild(script)
  })
  return googleMapsScriptPromise
}

export default {
  name: 'MapaSucursales',
  components: { Alerta, carga },
  mixins: [validarErrores],
  data () {
    return {
      cargar: false,
      syncing: false,
      puntos: [],
      filtroCiudad: null,
      filtroEscuela: null,
      filtroTipo: null,
      mostrarInactivos: false,
      mostrarTeachers: false,
      sucursalRutaId: null,
      puntoSinCoordsId: null,
      sinCoordsDialog: false,
      tipoOrigen: 'usuario',
      origenPlantelId: null,
      origenLat: null,
      origenLng: null,
      origenFuente: null,
      origenEtiqueta: '',
      origenPrecision: null,
      marcarOrigenActivo: false,
      geoLoading: false,
      map: null,
      markersLayer: [],
      routeLayer: [],
      origenLayer: [],
      origenMarker: null,
      origenCirculo: null,
      mapClickHandler: null,
      editorMapClickHandler: null,
      editorPreviewMarker: null,
      infoWindow: null,
      infoWindowTimer: null,
      markerById: {},
      seleccionado: null,
      notaEdit: '',
      notaSaving: false,
      rutaLoading: false,
      rutaInfo: null,
      chatMensajes: [],
      chatInput: '',
      chatLoading: false,
      mapsJsKey: null,
      mapLoadError: '',
      editorDialog: false,
      editorEsNuevo: true,
      editorSaving: false,
      editorPickActive: false,
      editorForm: {
        id: null,
        tipo: 'custom',
        nombre: '',
        ciudad: null,
        escuela: null,
        direccion: '',
        latitud: null,
        longitud: null,
        activo: true,
      },
      modoRutaEmbed: 'driving',
      opcionesCiudad: ['CDMX', 'MTY', 'GDL'],
      opcionesEscuela: [
        { escuela: 1, nombre: 'INBI' },
        { escuela: 2, nombre: 'FAST' },
      ],
      opcionesTipo: [
        { tipo: 'sucursal', nombre: 'Sucursales' },
        { tipo: 'teacher', nombre: 'Teachers' },
        { tipo: 'custom', nombre: 'Otras ubicaciones' },
      ],
      opcionesTipoEdicion: [
        { tipo: 'custom', nombre: 'Otra ubicación' },
        { tipo: 'teacher', nombre: 'Teacher' },
        { tipo: 'sucursal', nombre: 'Sucursal' },
      ],
      opcionesOrigen: [
        { value: 'usuario', nombre: 'Mi ubicación' },
        { value: 'sucursal', nombre: 'Otra sucursal' },
      ],
      menuPropsSelect: {
        zIndex: 5000,
        offsetY: true,
        nudgeBottom: 4,
      },
    }
  },
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    puntosFiltrados () {
      return (this.puntos || []).filter((p) => {
        if (this.filtroCiudad && p.ciudad !== this.filtroCiudad) return false
        if (this.filtroEscuela && Number(p.escuela) !== Number(this.filtroEscuela)) return false
        if (this.filtroTipo && p.tipo !== this.filtroTipo) return false
        if (!this.mostrarTeachers && p.tipo === 'teacher') return false
        return true
      })
    },
    puntosConCoords () {
      return (this.puntos || []).filter((p) => {
        if (p.tipo !== 'sucursal' || Number(p.activo) === 0 || p.latitud == null || p.longitud == null) return false
        const lat = Number(p.latitud)
        const lng = Number(p.longitud)
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false
        // Red de seguridad: solo México
        return lat >= 14.5 && lat <= 32.8 && lng >= -118.5 && lng <= -86.5
      })
    },
    puntosSinCoords () {
      return (this.puntos || []).filter((p) => p.latitud == null || p.longitud == null)
    },
    origenCoordsStr () {
      if (this.tipoOrigen === 'usuario' && this.origenLat != null && this.origenLng != null) {
        return this.origenLat + ',' + this.origenLng
      }
      if (this.tipoOrigen === 'teacher' && this.seleccionado &&
          this.seleccionado.tipo === 'teacher' &&
          this.seleccionado.latitud != null && this.seleccionado.longitud != null) {
        return Number(this.seleccionado.latitud) + ',' + Number(this.seleccionado.longitud)
      }
      if (this.tipoOrigen === 'sucursal' && this.origenPlantelId) {
        const p = this.puntosConCoords.find((x) => Number(x.id_referencia) === Number(this.origenPlantelId))
        if (p) return Number(p.latitud) + ',' + Number(p.longitud)
      }
      return null
    },
    opcionesOrigenVisibles () {
      const opciones = this.opcionesOrigen.filter((opcion) => opcion.value !== 'teacher')
      if (this.seleccionado && this.seleccionado.tipo === 'teacher' &&
          this.seleccionado.latitud != null && this.seleccionado.longitud != null) {
        opciones.push({ value: 'teacher', nombre: 'Teacher seleccionado' })
      }
      return opciones
    },
    destinoCoordsStr () {
      const destino = this.destinoRutaPunto
      if (!destino || destino.latitud == null || destino.longitud == null) return null
      return Number(destino.latitud) + ',' + Number(destino.longitud)
    },
    sucursalesRuta () {
      if (!this.seleccionado || this.seleccionado.tipo !== 'teacher') return null
      const lat = Number(this.seleccionado.latitud)
      const lng = Number(this.seleccionado.longitud)
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return []
      return (this.puntos || []).filter((p) => {
        return p.tipo === 'sucursal' && Number(p.activo) !== 0 &&
          p.latitud != null && p.longitud != null
      }).map((p) => {
        const distanciaKm = this.distanciaKm(lat, lng, Number(p.latitud), Number(p.longitud))
        return {
          ...p,
          distanciaKm,
          nombreRuta: p.nombre + ' · ' + distanciaKm.toFixed(1) + ' km',
        }
      }).sort((a, b) => a.distanciaKm - b.distanciaKm)
    },
    sucursalCercana () {
      const sucursales = this.sucursalesRuta
      return sucursales && sucursales.length ? sucursales[0] : null
    },
    destinoRutaPunto () {
      if (this.seleccionado && this.seleccionado.tipo === 'teacher') {
        const elegida = this.sucursalesRuta.find((p) => Number(p.id) === Number(this.sucursalRutaId))
        return elegida || this.sucursalCercana
      }
      return this.seleccionado
    },
  },
  watch: {
    filtroCiudad () { this.refreshMarkers() },
    filtroEscuela () { this.refreshMarkers() },
    filtroTipo () { this.refreshMarkers() },
    mostrarTeachers () { this.refreshMarkers() },
    mostrarInactivos () { this.cargarPuntos(false) },
    sucursalRutaId () {
      if (this.seleccionado && this.seleccionado.tipo === 'teacher') {
        this.calcularRutaSeleccion()
      }
    },
    tipoOrigen (val) {
      if (val !== 'usuario') {
        this.marcarOrigenActivo = false
        this.desactivarClickMapaOrigen()
      }
      if (this.seleccionado) this.calcularRutaSeleccion()
    },
    origenPlantelId () {
      if (this.tipoOrigen === 'sucursal' && this.seleccionado) {
        this.calcularRutaSeleccion()
      }
    },
    modoRutaEmbed () {
      if (this.rutaInfo) {
        this.dibujarRuta(this.rutaInfo)
      } else if (this.seleccionado) {
        this.calcularRutaSeleccion()
      }
    },
  },
  mounted () {
    this.cargarConfigMaps().then(() => this.initMap())
    this.cargarPuntos(true)
  },
  beforeDestroy () {
    this.desactivarClickMapaOrigen()
    this.desactivarSeleccionCoordenadaEditor()
    this.limpiarEditorPreview()
    if (this.infoWindowTimer) clearTimeout(this.infoWindowTimer)
    if (this.infoWindow) this.infoWindow.close()
    this.limpiarMarcadores()
    this.limpiarRutas()
    this.limpiarOrigen()
    this.map = null
  },
  methods: {
    async initMap () {
      if (!this.$refs.mapEl || this.map) return
      if (!this.mapsJsKey) {
        this.mapLoadError = 'No hay una key de navegador configurada para Google Maps.'
        return
      }
      try {
        await cargarGoogleMapsScript(this.mapsJsKey)
        const maps = window.google.maps
        this.map = new maps.Map(this.$refs.mapEl, {
          center: { lat: 23.6, lng: -100.5 },
          zoom: 5,
          mapTypeControl: true,
          streetViewControl: false,
          fullscreenControl: true,
          clickableIcons: false,
          styles: [
            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
            { featureType: 'transit', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            { featureType: 'road.local', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'administrative.neighborhood', elementType: 'labels', stylers: [{ visibility: 'off' }] },
          ],
        })
        this.infoWindow = new maps.InfoWindow()
        this.mapLoadError = ''
        this.refreshMarkers()
      } catch (error) {
        this.mapLoadError = error.message || 'No se pudo cargar Google Maps.'
        this.validarError(this.mapLoadError)
      }
    },
    coordsEnMexico (lat, lng) {
      return Number.isFinite(lat) && Number.isFinite(lng) &&
        lat >= 14.5 && lat <= 32.8 && lng >= -118.5 && lng <= -86.5
    },
    aplicarOrigenUsuario (lat, lng, meta) {
      const la = Number(lat)
      const ln = Number(lng)
      if (!this.coordsEnMexico(la, ln)) {
        this.validarError('Esa ubicación está fuera de México. Verifica GPS o marca un punto válido en el mapa.')
        return false
      }
      this.origenLat = la
      this.origenLng = ln
      this.origenFuente = (meta && meta.fuente) || 'manual'
      this.origenEtiqueta = (meta && meta.etiqueta) || 'Ubicación manual'
      this.origenPrecision = meta && meta.precision != null ? Number(meta.precision) : null
      const esGps = this.origenFuente === 'gps' || this.origenFuente === 'gps_baja'
      this.marcarOrigenActivo = false
      this.desactivarClickMapaOrigen()
      this.actualizarMarcadorOrigen()
      if (esGps) this.enfocarOrigenUsuario()
      if (this.seleccionado) {
        const ruta = this.calcularRutaSeleccion()
        if (esGps && ruta && ruta.then) {
          ruta.then(() => this.enfocarOrigenUsuario())
        }
      }
      return true
    },
    enfocarOrigenUsuario () {
      if (!this.map || this.origenLat == null || this.origenLng == null) return
      this.map.panTo({
        lat: Number(this.origenLat),
        lng: Number(this.origenLng),
      })
      this.map.setZoom(this.origenPrecision && this.origenPrecision <= 80 ? 17 : 15)
    },
    limpiarMarcadores () {
      ;(this.markersLayer || []).forEach((marker) => marker.setMap(null))
      this.markersLayer = []
      this.markerById = {}
    },
    mostrarInfoSucursal (p, marker) {
      if (!this.infoWindow || !this.map || !p) return
      if (this.infoWindowTimer) {
        clearTimeout(this.infoWindowTimer)
        this.infoWindowTimer = null
      }
      const content = document.createElement('div')
      content.className = 'mapa-sucursal-info'
      content.style.minWidth = '190px'
      content.style.maxWidth = '260px'
      content.style.padding = '4px 2px'
      const nombre = document.createElement('div')
      nombre.className = 'mapa-sucursal-info__nombre'
      nombre.style.fontSize = '16px'
      nombre.style.fontWeight = '700'
      nombre.style.lineHeight = '1.25'
      nombre.textContent = p.nombre || 'Sucursal'
      const escuela = document.createElement('div')
      escuela.className = 'mapa-sucursal-info__escuela'
      escuela.style.display = 'inline-block'
      escuela.style.marginTop = '4px'
      escuela.style.padding = '2px 7px'
      escuela.style.borderRadius = '10px'
      escuela.style.background = p.tipo === 'teacher'
        ? '#5E35B1'
        : p.tipo === 'custom'
          ? '#00897B'
          : Number(p.escuela) === 2 ? '#EF6C00' : '#1976D2'
      escuela.style.color = '#FFFFFF'
      escuela.style.fontSize = '11px'
      escuela.style.fontWeight = '700'
      escuela.textContent = this.etiquetaTipoPunto(p) + (Number(p.activo) === 0 ? ' · INACTIVA' : '')
      if (typeof this.infoWindow.setHeaderContent === 'function') {
        this.infoWindow.setHeaderContent(nombre)
      } else {
        content.appendChild(nombre)
      }
      content.appendChild(escuela)
      if (p.direccion) {
        const direccion = document.createElement('div')
        direccion.className = 'mapa-sucursal-info__direccion'
        direccion.style.marginTop = '6px'
        direccion.style.color = '#607D8B'
        direccion.style.fontSize = '12px'
        direccion.style.lineHeight = '1.35'
        direccion.textContent = p.direccion
        content.appendChild(direccion)
      }
      if (p.nota) {
        const nota = document.createElement('div')
        nota.className = 'mapa-sucursal-info__nota'
        nota.style.marginTop = '7px'
        nota.style.paddingTop = '5px'
        nota.style.borderTop = '1px solid #ECEFF1'
        nota.style.color = '#6D4C41'
        nota.style.fontSize = '12px'
        nota.textContent = 'Nota: ' + p.nota
        content.appendChild(nota)
      }
      this.infoWindow.setContent(content)
      this.infoWindow.open(this.map, marker)
    },
    programarCierreInfoSucursal () {
      if (!this.infoWindow) return
      if (this.infoWindowTimer) clearTimeout(this.infoWindowTimer)
      this.infoWindowTimer = setTimeout(() => {
        if (this.infoWindow) this.infoWindow.close()
        this.infoWindowTimer = null
      }, 1500)
    },
    limpiarRutas () {
      ;(this.routeLayer || []).forEach((line) => line.setMap(null))
      this.routeLayer = []
    },
    limpiarOrigen () {
      ;(this.origenLayer || []).forEach((item) => item.setMap(null))
      this.origenLayer = []
      this.origenMarker = null
      this.origenCirculo = null
    },
    instruccionesDesdeLeg (leg) {
      const pasos = leg && Array.isArray(leg.steps) ? leg.steps : []
      return pasos.map((paso) => {
        const detalle = paso.transit_details || paso.transit
        if (paso.travel_mode === 'TRANSIT' && detalle) {
          const linea = detalle.line || {}
          const vehiculo = linea.vehicle && (linea.vehicle.name || linea.vehicle.type)
          const nombreLinea = linea.short_name || linea.name
          const titulo = [vehiculo, nombreLinea].filter(Boolean).join(' · ')
          const salida = detalle.departure_stop && detalle.departure_stop.name
          const llegada = detalle.arrival_stop && detalle.arrival_stop.name
          const paradas = detalle.num_stops != null ? ' · ' + detalle.num_stops + ' paradas' : ''
          return {
            tipo: 'transit',
            texto: (titulo || 'Transporte público') +
              (salida && llegada ? ': ' + salida + ' → ' + llegada : '') + paradas,
          }
        }
        const texto = String(paso.instructions || 'Caminar')
          .replace(/<[^>]+>/g, '')
          .replace(/&nbsp;/g, ' ')
          .trim()
        return {
          tipo: 'walking',
          texto: texto + (paso.duration && paso.duration.text ? ' · ' + paso.duration.text : ''),
        }
      }).filter((paso) => paso.texto)
    },
    actualizarMarcadorOrigen () {
      if (!this.map || !window.google || !window.google.maps) return
      this.limpiarOrigen()
      if (this.origenLat == null || this.origenLng == null) return
      const lat = Number(this.origenLat)
      const lng = Number(this.origenLng)
      const maps = window.google.maps
      this.origenMarker = new maps.Marker({
        map: this.map,
        position: { lat: lat, lng: lng },
        title: 'Tu origen',
        zIndex: 1000,
        icon: {
          path: maps.SymbolPath.CIRCLE,
            scale: 10,
          fillColor: '#2E7D32',
          fillOpacity: 1,
          strokeColor: '#FFFFFF',
          strokeWeight: 3,
        },
      })
      this.origenLayer.push(this.origenMarker)
      if (this.origenPrecision && this.origenPrecision > 0 && this.origenPrecision < 5000) {
        this.origenCirculo = new maps.Circle({
          map: this.map,
          center: { lat: lat, lng: lng },
          radius: this.origenPrecision,
          strokeColor: '#2E7D32',
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: '#66BB6A',
          fillOpacity: 0.15,
        })
        this.origenLayer.push(this.origenCirculo)
      }
    },
    activarMarcarOrigen () {
      if (!this.map) return
      this.marcarOrigenActivo = !this.marcarOrigenActivo
      if (this.marcarOrigenActivo) {
        this.validarSuccess('Haz click en el mapa donde estás para fijar el origen del traslado.')
        this.mapClickHandler = this.map.addListener('click', (e) => {
          if (!e || !e.latLng) return
          const ok = this.aplicarOrigenUsuario(e.latLng.lat(), e.latLng.lng(), {
            fuente: 'manual',
            etiqueta: 'Marcado en mapa',
          })
          if (ok) this.validarSuccess('Origen marcado en el mapa')
        })
        this.map.setOptions({ draggableCursor: 'crosshair' })
      } else {
        this.desactivarClickMapaOrigen()
      }
    },
    desactivarClickMapaOrigen () {
      this.marcarOrigenActivo = false
      if (this.mapClickHandler) {
        this.mapClickHandler.remove()
        this.mapClickHandler = null
      }
      if (this.map) this.map.setOptions({ draggableCursor: null })
    },
    distanciaKm (lat1, lng1, lat2, lng2) {
      const rad = Math.PI / 180
      const dLat = (lat2 - lat1) * rad
      const dLng = (lng2 - lng1) * rad
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * rad) * Math.cos(lat2 * rad) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2)
      return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    },
    mensajeErrorHttp (error, fallback) {
      return (error && error.body && error.body.message) ||
        (error && error.response && error.response.data && error.response.data.message) ||
        (error && error.message) ||
        fallback
    },
    etiquetaTipoPunto (p) {
      if (!p) return 'Ubicación'
      if (p.tipo === 'teacher') return 'Teacher'
      if (p.tipo === 'custom') return 'Otra ubicación'
      return Number(p.escuela) === 2 ? 'FAST' : 'INBI'
    },
    colorPunto (p) {
      if (!p || Number(p.activo) === 0) return 'grey'
      if (p.tipo === 'teacher') return 'deep-purple'
      if (p.tipo === 'custom') return 'teal'
      return Number(p.escuela) === 2 ? 'orange' : 'blue'
    },
    etiquetaGeoFuente (fuente) {
      const map = {
        link_maps: 'Pin Google Maps (ERP)',
        catalogo_oficial: 'Catálogo verificado',
        inbi_ubicaciones_json: 'Pin Google Maps (INBI oficial)',
        planteles_erp: 'Coordenadas ERP',
        sucursales_geo_legacy: 'Referencia legacy',
        manual: 'Captura manual',
        corregido_manual: 'Corregido manualmente',
      }
      if (map[fuente]) return map[fuente]
      if (String(fuente || '').indexOf('geocode_catalogo+google') === 0) return 'Geocodificado catálogo (Google)'
      if (String(fuente || '').indexOf('geocode_catalogo+photon') === 0) return 'Geocodificado catálogo (Photon)'
      if (String(fuente || '').indexOf('geocode_oficial+google') === 0) return 'Geocodificado (Google)'
      if (String(fuente || '').indexOf('geocode_oficial+photon') === 0) return 'Geocodificado (Photon)'
      if (String(fuente || '').indexOf('geocode_erp+google') === 0) return 'Geocodificado ERP (Google)'
      if (String(fuente || '').indexOf('geocode_erp+photon') === 0) return 'Geocodificado ERP (Photon)'
      if (String(fuente || '').indexOf('teacher+google') === 0) return 'Teacher geocodificado (Google)'
      if (String(fuente || '').indexOf('teacher+photon') === 0) return 'Teacher geocodificado (Photon)'
      return fuente || ''
    },
    etiquetaProveedorRuta (ruta) {
      if (!ruta) return ''
      if (ruta.proveedor === 'osrm' || ruta.sin_trafico) return 'estimado, sin tráfico en vivo'
      if (ruta.proveedor === 'google' && ruta.con_trafico) return 'Google Maps, tráfico actual'
      if (ruta.proveedor === 'google') return 'Google Maps'
      return ruta.proveedor || ''
    },
    refreshMarkers () {
      if (!this.map || !window.google || !window.google.maps) return
      this.limpiarMarcadores()
      const maps = window.google.maps
      const bounds = new maps.LatLngBounds()
      let total = 0
      this.puntosFiltrados.forEach((p) => {
        if (p.latitud == null || p.longitud == null) return
        const lat = Number(p.latitud)
        const lng = Number(p.longitud)
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return
        if (lat < 14.5 || lat > 32.8 || lng < -118.5 || lng > -86.5) return
        const color = p.tipo === 'teacher'
          ? '#5E35B1'
          : p.tipo === 'custom'
            ? '#00897B'
            : Number(p.activo) === 0
              ? '#757575'
              : Number(p.escuela) === 2 ? '#EF6C00' : '#1565C0'
        const m = new maps.Marker({
          map: this.map,
          position: { lat: lat, lng: lng },
          title: p.nombre,
          icon: {
            path: maps.SymbolPath.CIRCLE,
            scale: Number(p.activo) === 0 ? 8 : 10,
            fillColor: color,
            fillOpacity: Number(p.activo) === 0 ? 0.65 : 1,
            strokeColor: '#FFFFFF',
            strokeWeight: 2,
          },
        })
        m.addListener('mouseover', () => this.mostrarInfoSucursal(p, m))
        m.addListener('mouseout', () => this.programarCierreInfoSucursal())
        m.addListener('click', () => this.onMarkerClick(p))
        this.markersLayer.push(m)
        this.markerById[p.id] = m
        bounds.extend({ lat: lat, lng: lng })
        total++
      })
      if (total === 1) {
        this.map.setCenter(bounds.getCenter())
        this.map.setZoom(14)
      } else if (total > 1) {
        this.map.fitBounds(bounds, { top: 40, right: 40, bottom: 40, left: 40 })
      }
    },
    cargarConfigMaps () {
      return this.$http.get('kpi.mapa.config').then((response) => {
        const data = response.data || {}
        this.mapsJsKey = data.google_maps_browser_key || data.google_maps_embed_key || null
      }).catch(() => {
        this.mapLoadError = 'No se pudo obtener la configuración de Google Maps.'
      })
    },
    cargarPuntos (sync) {
      this.cargar = true
      const partes = []
      if (sync) partes.push('sync=1')
      partes.push('tipo=all')
      if (this.mostrarInactivos) partes.push('incluir_inactivos=1')
      partes.push('incluir_sin_coords=1')
      const q = '?' + partes.join('&')
      return this.$http.get('kpi.mapa.planteles' + q).then((response) => {
        this.puntos = (response.data && response.data.puntos) || []
        this.$nextTick(() => this.refreshMarkers())
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al cargar planteles'))
      }).finally(() => {
        this.cargar = false
      })
    },
    sincronizar () {
      if (typeof window !== 'undefined' && !window.confirm(
        'La sincronización actualizará sucursales y teachers con la información del ERP y puede sobrescribir correcciones manuales. ¿Deseas continuar?'
      )) {
        return Promise.resolve()
      }
      this.syncing = true
      return this.$http.post('kpi.mapa.sync', { forzar: 1 }).then(() => {
        return this.cargarPuntos(false)
      }).then(() => {
        this.validarSuccess('Sucursales y teachers sincronizados')
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al sincronizar'))
      }).finally(() => {
        this.syncing = false
      })
    },
    obtenerMiUbicacion () {
      const self = this
      if (typeof navigator === 'undefined' || !navigator.geolocation) {
        this.validarError('Tu navegador no soporta GPS. Usa "Marcar en mapa" o elige "Otra sucursal" como origen.')
        return
      }
      if (!window.isSecureContext) {
        this.validarError('El GPS requiere HTTPS o localhost. Usa "Marcar en mapa" para indicar tu origen.')
        return
      }
      this.geoLoading = true
      this.desactivarClickMapaOrigen()

      let mejor = null
      let watchId = null
      let terminado = false

      const finalizar = (lat, lng, meta, aviso) => {
        if (terminado) return
        terminado = true
        if (watchId != null) navigator.geolocation.clearWatch(watchId)
        self.geoLoading = false
        if (self.aplicarOrigenUsuario(lat, lng, meta) && aviso) {
          self.validarSuccess(aviso)
        }
      }

      const evaluarPosicion = (pos) => {
        if (!pos || !pos.coords) return
        const lat = pos.coords.latitude
        const lng = pos.coords.longitude
        const acc = pos.coords.accuracy
        if (!self.coordsEnMexico(lat, lng)) return
        if (!mejor || acc < mejor.acc) {
          mejor = { lat: lat, lng: lng, acc: acc }
        }
        if (acc <= 80) {
          finalizar(lat, lng, {
            fuente: 'gps',
            etiqueta: 'GPS (±' + Math.round(acc) + ' m)',
            precision: acc,
          }, 'Ubicación GPS obtenida')
        }
      }

      const falloGps = (err) => {
        if (terminado) return
        if (mejor) {
          finalizar(mejor.lat, mejor.lng, {
            fuente: 'gps_baja',
            etiqueta: 'GPS aproximado (±' + Math.round(mejor.acc) + ' m)',
            precision: mejor.acc,
          }, 'GPS con precisión limitada — si la ruta no cuadra, marca tu punto en el mapa.')
          return
        }
        terminado = true
        if (watchId != null) navigator.geolocation.clearWatch(watchId)
        self.geoLoading = false
        const code = err && err.code
        if (code === 1) {
          self.validarError(
            'Permiso de ubicación denegado. En la barra del navegador (candado) activa Ubicación → Permitir, o usa "Marcar en mapa".'
          )
        } else {
          self.validarError(
            'No se pudo obtener el GPS. Usa "Marcar en mapa" haciendo click donde estás, o elige "Otra sucursal".'
          )
        }
      }

      watchId = navigator.geolocation.watchPosition(evaluarPosicion, falloGps, {
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 0,
      })

      setTimeout(function () {
        if (terminado) return
        if (mejor) {
          finalizar(mejor.lat, mejor.lng, {
            fuente: 'gps_baja',
            etiqueta: 'GPS (±' + Math.round(mejor.acc) + ' m)',
            precision: mejor.acc,
          }, null)
        } else {
          falloGps({ code: 2 })
        }
      }, 12000)
    },
    onMarkerClick (p) {
      this.seleccionado = p
      this.notaEdit = p.nota || ''
      this.rutaInfo = null
      this.sucursalRutaId = p.tipo === 'teacher' && this.sucursalCercana
        ? this.sucursalCercana.id
        : null
      this.tipoOrigen = p.tipo === 'teacher' && p.latitud != null && p.longitud != null
        ? 'teacher'
        : this.tipoOrigen === 'teacher' ? 'usuario' : this.tipoOrigen
      if (this.map) {
        this.map.panTo({ lat: Number(p.latitud), lng: Number(p.longitud) })
      }
      this.calcularRutaSeleccion()
    },
    buildOrigenPayload () {
      if (this.tipoOrigen === 'teacher' && this.seleccionado &&
          this.seleccionado.tipo === 'teacher' &&
          this.seleccionado.latitud != null && this.seleccionado.longitud != null) {
        return {
          origen_lat: Number(this.seleccionado.latitud),
          origen_lng: Number(this.seleccionado.longitud),
          origen_label: this.seleccionado.nombre || 'Teacher seleccionado',
        }
      }
      if (this.tipoOrigen === 'usuario') {
        if (this.origenLat == null || this.origenLng == null) return null
        if (this.origenFuente === 'ip') return null
        return {
          origen_lat: this.origenLat,
          origen_lng: this.origenLng,
          origen_label: this.origenEtiqueta || 'Mi ubicación',
        }
      }
      if (this.origenPlantelId) {
        return { origen_id_plantel: this.origenPlantelId }
      }
      return null
    },
    calcularRutaSeleccion () {
      if (!this.seleccionado) return
      const origen = this.buildOrigenPayload()
      if (!origen) {
        const msg = this.tipoOrigen === 'usuario' && this.origenFuente === 'ip'
          ? 'La ubicación por IP no es fiable. Usa GPS o marca tu punto en el mapa.'
          : 'Define un origen: pulsa Usar GPS, Marcar en mapa, o elige Otra sucursal.'
        this.rutaInfo = { transit: { mensaje: msg } }
        return
      }
      this.rutaLoading = true
      return this.calcularRutasGoogle(origen).then((rutas) => {
        this.rutaInfo = rutas
        this.dibujarRuta(rutas)
      }).catch((error) => {
        this.rutaInfo = null
        this.limpiarRutas()
        this.validarError(error.message || 'Error al calcular ruta con Google Maps')
      }).finally(() => {
        this.rutaLoading = false
      })
    },
    calcularRutasGoogle (origen) {
      if (!this.map || !window.google || !window.google.maps) {
        return Promise.reject(new Error('Google Maps todavía no está listo. Recarga la página e inténtalo de nuevo.'))
      }
      const maps = window.google.maps
      const origenCoords = String(this.origenCoordsStr || '').split(',')
      const inicio = {
        lat: Number(origen.origen_lat != null ? origen.origen_lat : origenCoords[0]),
        lng: Number(origen.origen_lng != null ? origen.origen_lng : origenCoords[1]),
      }
      const puntoDestino = this.destinoRutaPunto
      if (!puntoDestino || puntoDestino.latitud == null || puntoDestino.longitud == null) {
        return Promise.reject(new Error('No hay una sucursal con coordenadas para calcular la ruta.'))
      }
      const destino = {
        lat: Number(puntoDestino.latitud),
        lng: Number(puntoDestino.longitud),
      }
      const consultar = (modo) => new Promise((resolve) => {
        const request = {
          origin: inicio,
          destination: destino,
          travelMode: modo === 'transit' ? maps.TravelMode.TRANSIT : maps.TravelMode.DRIVING,
          provideRouteAlternatives: false,
        }
        if (modo === 'driving') {
          request.drivingOptions = {
            departureTime: new Date(),
            trafficModel: maps.TrafficModel.BEST_GUESS,
          }
        } else {
          request.transitOptions = {
            departureTime: new Date(),
          }
        }
        new maps.DirectionsService().route(request, (result, status) => {
          if (status !== 'OK' || !result || !result.routes || !result.routes[0]) {
            const detalle = status === 'REQUEST_DENIED'
              ? 'Directions API no está habilitada o la key no autoriza este dominio.'
              : status === 'ZERO_RESULTS'
                ? 'Google Maps no encontró una ruta disponible para este modo.'
                : 'Google Maps no pudo calcular esta ruta (' + status + ').'
            resolve({
              modo: modo,
              disponible: false,
              mensaje: modo === 'transit' && status === 'ZERO_RESULTS'
                ? 'Sin ruta de transporte público disponible'
                : detalle,
              proveedor: 'google',
            })
            return
          }
          const route = result.routes[0]
          const leg = route.legs && route.legs[0]
          const baseDuration = leg && leg.duration
          const trafficDuration = leg && leg.duration_in_traffic
          const duration = trafficDuration && trafficDuration.value != null
            ? trafficDuration
            : baseDuration
          resolve({
            modo: modo,
            disponible: true,
            duracion_segundos: duration && duration.value != null ? Number(duration.value) : null,
            duracion_texto: duration && duration.text ? duration.text : null,
            distancia_metros: leg && leg.distance && leg.distance.value != null
              ? Number(leg.distance.value)
              : null,
            instrucciones: this.instruccionesDesdeLeg(leg),
            polyline: (route.overview_path || []).map((point) => [point.lat(), point.lng()]),
            proveedor: 'google',
            con_trafico: modo === 'driving' && !!trafficDuration,
          })
        })
      })
      return Promise.all([consultar('driving'), consultar('transit')]).then((resultados) => ({
        driving: resultados[0],
        transit: resultados[1],
      }))
    },
    dibujarRuta (rutas) {
      if (!this.map || !window.google || !window.google.maps) return
      this.limpiarRutas()
      if (!rutas) return

      let poly = null
      let color = '#1565C0'
      let esReferenciaAuto = false

      if (this.modoRutaEmbed === 'transit' && rutas.transit && rutas.transit.polyline && rutas.transit.polyline.length) {
        poly = rutas.transit.polyline
        color = '#EF6C00'
      } else if (rutas.driving && rutas.driving.polyline && rutas.driving.polyline.length) {
        poly = rutas.driving.polyline
        color = '#1565C0'
        esReferenciaAuto = this.modoRutaEmbed === 'transit'
      }

      if (!poly || !poly.length) return

      const maps = window.google.maps
      const line = new maps.Polyline({
        map: this.map,
        path: poly.map((point) => ({ lat: Number(point[0]), lng: Number(point[1]) })),
        geodesic: true,
        strokeColor: color,
        strokeOpacity: 0.9,
        strokeWeight: 5,
      })
      this.routeLayer.push(line)

      const bounds = new maps.LatLngBounds()
      poly.forEach((point) => bounds.extend({ lat: Number(point[0]), lng: Number(point[1]) }))
      if (this.origenLat != null && this.origenLng != null) {
        bounds.extend({ lat: Number(this.origenLat), lng: Number(this.origenLng) })
      }
      if (this.destinoRutaPunto && this.destinoRutaPunto.latitud != null) {
        bounds.extend({
          lat: Number(this.destinoRutaPunto.latitud),
          lng: Number(this.destinoRutaPunto.longitud),
        })
      }
      this.map.fitBounds(bounds, { top: 40, right: 40, bottom: 40, left: 40 })

      if (esReferenciaAuto && !this._avisoRutaReferencia) {
        this._avisoRutaReferencia = true
        this.validarSuccess('Línea azul: ruta en auto (referencia). Transporte público requiere API de Google.')
      }
    },
    abrirNuevoPunto () {
      this.editorEsNuevo = true
      this.editorForm = {
        id: null,
        tipo: 'custom',
        nombre: '',
        ciudad: null,
        escuela: null,
        direccion: '',
        latitud: null,
        longitud: null,
        activo: true,
      }
      this.editorDialog = true
    },
    seleccionarPuntoSinCoords (id) {
      const punto = this.puntos.find((p) => Number(p.id) === Number(id))
      this.puntoSinCoordsId = null
      this.sinCoordsDialog = false
      if (!punto) return
      this.seleccionado = punto
      this.notaEdit = punto.nota || ''
      this.abrirEditarPunto()
    },
    abrirEditarPunto () {
      if (!this.seleccionado) return
      const p = this.seleccionado
      this.editorEsNuevo = false
      this.editorForm = {
        id: p.id,
        tipo: p.tipo || 'custom',
        nombre: p.nombre || '',
        ciudad: p.ciudad || null,
        escuela: p.escuela == null ? null : Number(p.escuela),
        direccion: p.direccion || '',
        latitud: p.latitud,
        longitud: p.longitud,
        activo: Number(p.activo) !== 0,
      }
      this.editorDialog = true
    },
    cerrarEditorPunto () {
      this.editorDialog = false
      this.desactivarSeleccionCoordenadaEditor()
      this.limpiarEditorPreview()
    },
    activarSeleccionCoordenadaEditor () {
      if (!this.map) {
        this.validarError('Google Maps todavía no está listo.')
        return
      }
      if (this.editorPickActive) {
        this.desactivarSeleccionCoordenadaEditor()
        return
      }
      this.desactivarClickMapaOrigen()
      this.editorPickActive = true
      this.editorDialog = false
      this.mapClickHandler = this.map.addListener('click', (e) => {
        if (!e || !e.latLng) return
        this.$set(this.editorForm, 'latitud', Number(e.latLng.lat()).toFixed(7))
        this.$set(this.editorForm, 'longitud', Number(e.latLng.lng()).toFixed(7))
        this.actualizarEditorPreview()
        this.desactivarSeleccionCoordenadaEditor()
        this.editorDialog = true
        this.validarSuccess('Coordenadas seleccionadas en el mapa')
      })
      this.map.setOptions({ draggableCursor: 'crosshair' })
    },
    desactivarSeleccionCoordenadaEditor () {
      this.editorPickActive = false
      if (this.mapClickHandler) {
        this.mapClickHandler.remove()
        this.mapClickHandler = null
      }
      if (this.map) this.map.setOptions({ draggableCursor: null })
    },
    actualizarEditorPreview () {
      if (!this.map || !window.google || !window.google.maps) return
      const lat = Number(this.editorForm.latitud)
      const lng = Number(this.editorForm.longitud)
      if (!this.coordsEnMexico(lat, lng)) {
        this.limpiarEditorPreview()
        return
      }
      if (!this.editorPreviewMarker) {
        this.editorPreviewMarker = new window.google.maps.Marker({
          map: this.map,
          title: 'Ubicación en edición',
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 9,
            fillColor: '#00897B',
            fillOpacity: 0.9,
            strokeColor: '#FFFFFF',
            strokeWeight: 2,
          },
        })
      }
      this.editorPreviewMarker.setPosition({ lat: lat, lng: lng })
      this.map.panTo({ lat: lat, lng: lng })
    },
    limpiarEditorPreview () {
      if (this.editorPreviewMarker) {
        this.editorPreviewMarker.setMap(null)
        this.editorPreviewMarker = null
      }
    },
    guardarPunto () {
      const nombre = String(this.editorForm.nombre || '').trim()
      const lat = Number(this.editorForm.latitud)
      const lng = Number(this.editorForm.longitud)
      if (!nombre || !Number.isFinite(lat) || !Number.isFinite(lng)) {
        this.validarError('Captura nombre, latitud y longitud antes de guardar.')
        return Promise.resolve()
      }
      this.editorSaving = true
      const payload = {
        id: this.editorForm.id,
        tipo: this.editorForm.tipo,
        nombre: nombre,
        ciudad: this.editorForm.ciudad || null,
        escuela: this.editorForm.escuela || null,
        direccion: String(this.editorForm.direccion || '').trim(),
        latitud: lat,
        longitud: lng,
        activo: this.editorForm.activo ? 1 : 0,
      }
      const request = this.editorEsNuevo
        ? this.$http.post('kpi.mapa.punto', payload)
        : this.$http.put('kpi.mapa.punto', payload)
      return request.then((response) => {
        const guardado = response.data
        this.cerrarEditorPunto()
        return this.cargarPuntos(false).then(() => {
          const actualizado = this.puntos.find((p) => Number(p.id) === Number(guardado.id))
          if (actualizado) {
            this.seleccionado = actualizado
            this.notaEdit = actualizado.nota || ''
          }
          this.validarSuccess('Ubicación guardada')
        })
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al guardar ubicación'))
      }).finally(() => {
        this.editorSaving = false
      })
    },
    desactivarSeleccionado () {
      if (!this.seleccionado) return Promise.resolve()
      if (typeof window !== 'undefined' && !window.confirm(
        'La ubicación dejará de mostrarse en el mapa activo. ¿Deseas desactivarla?'
      )) return Promise.resolve()
      return this.$http.delete('kpi.mapa.punto/' + this.seleccionado.id).then(() => {
        this.rutaInfo = null
        this.seleccionado = null
        return this.cargarPuntos(false)
      }).then(() => {
        this.validarSuccess('Ubicación desactivada')
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al desactivar ubicación'))
      })
    },
    activarSeleccionado () {
      if (!this.seleccionado) return Promise.resolve()
      return this.$http.post('kpi.mapa.punto/' + this.seleccionado.id + '/activar').then((response) => {
        const punto = response.data
        return this.cargarPuntos(false).then(() => {
          this.seleccionado = this.puntos.find((p) => Number(p.id) === Number(punto.id)) || punto
          this.notaEdit = this.seleccionado.nota || ''
          this.validarSuccess('Ubicación activada')
        })
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al activar ubicación'))
      })
    },
    guardarNota () {
      if (!this.seleccionado) return
      this.notaSaving = true
      return this.$http.put('kpi.mapa.nota', {
        id_punto: this.seleccionado.id,
        nota: this.notaEdit,
      }).then((response) => {
        const p = response.data
        this.seleccionado = p
        const idx = this.puntos.findIndex((x) => x.id === p.id)
        if (idx >= 0) this.$set(this.puntos, idx, p)
        this.$nextTick(() => this.refreshMarkers())
        this.validarSuccess('Nota guardada')
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al guardar nota'))
      }).finally(() => {
        this.notaSaving = false
      })
    },
    esPedidoMarcarRuta (mensaje) {
      const t = String(mensaje || '').toLowerCase()
      return /(marca|muestra|dibuj|traza|pon)/.test(t) && /ruta/.test(t)
    },
    marcarRutaEnMapa (mensajeRespuesta) {
      if (this.rutaInfo) {
        this.$nextTick(() => this.dibujarRuta(this.rutaInfo))
        this.chatMensajes.push({ rol: 'ia', texto: mensajeRespuesta || 'Ruta marcada en el mapa.' })
        return true
      }
      if (this.seleccionado && this.buildOrigenPayload()) {
        return this.calcularRutaSeleccion().then(() => {
          this.chatMensajes.push({
            rol: 'ia',
            texto: mensajeRespuesta || 'Ruta calculada y marcada en el mapa.',
          })
        })
      }
      this.chatMensajes.push({
        rol: 'ia',
        texto: 'Primero elige una sucursal en el mapa y define tu origen (GPS o marcar en mapa).',
      })
      return true
    },
    enviarAsistente () {
      const mensaje = String(this.chatInput || '').trim()
      if (!mensaje) return
      this.chatMensajes.push({ rol: 'user', texto: mensaje })
      this.chatInput = ''
      if (this.esPedidoMarcarRuta(mensaje)) {
        this.chatLoading = true
        const done = this.marcarRutaEnMapa()
        if (done && done.then) {
          done.finally(() => { this.chatLoading = false })
        } else {
          this.chatLoading = false
        }
        return done
      }
      this.chatLoading = true
      const contexto = {
        origen_lat: this.origenLat,
        origen_lng: this.origenLng,
        origen_id_plantel: this.origenPlantelId,
        tipo_origen: this.tipoOrigen,
      }
      return this.$http.post('kpi.mapa.asistente', { mensaje: mensaje, contexto: contexto }).then((response) => {
        const data = response.data || {}
        this.chatMensajes.push({ rol: 'ia', texto: data.texto || 'Listo.' })
        this.aplicarAcciones(data.acciones || [])
      }).catch((error) => {
        let msg = 'Error del asistente'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.chatMensajes.push({ rol: 'ia', texto: msg })
      }).finally(() => {
        this.chatLoading = false
      })
    },
    aplicarAcciones (acciones) {
      ;(acciones || []).forEach((a) => {
        if (!a) return
        if (a.tipo === 'filtrar') {
          if (a.ciudad) this.filtroCiudad = a.ciudad
          if (a.escuela != null) this.filtroEscuela = a.escuela
        }
        if (a.tipo === 'resaltar' || a.tipo === 'mostrar_nota') {
          const p = this.puntos.find((x) =>
            (a.id_punto && x.id === a.id_punto) ||
            (a.id_plantel && Number(x.id_referencia) === Number(a.id_plantel))
          )
          if (p) this.onMarkerClick(p)
        }
        if (a.tipo === 'calcular_ruta' && a.ok && a.rutas) {
          this.rutaInfo = a.rutas
          if (a.destino && a.destino.id_plantel) {
            const p = this.puntos.find((x) => Number(x.id_referencia) === Number(a.destino.id_plantel))
            if (p) {
              this.seleccionado = p
              this.notaEdit = p.nota || ''
              if (this.map) {
                this.map.panTo({ lat: Number(p.latitud), lng: Number(p.longitud) })
              }
            }
          }
          this.$nextTick(() => this.dibujarRuta(a.rutas))
        }
        if (a.tipo === 'guardar_nota' && a.ok && a.punto) {
          const p = a.punto
          const idx = this.puntos.findIndex((x) => x.id === p.id)
          if (idx >= 0) this.$set(this.puntos, idx, p)
          this.seleccionado = p
          this.notaEdit = p.nota || ''
        }
      })
    },
  },
}
</script>

<style scoped>
.mapa-kpi-card {
  position: relative;
  z-index: 0;
  overflow: hidden;
}
.mapa-kpi {
  position: relative;
  height: 70vh;
  min-height: 420px;
  width: 100%;
  border-radius: 4px;
}
.mapa-origen-alerta {
  font-size: 16px;
}
.mapa-origen-alerta .body-2 {
  font-size: 16px !important;
}
.mapa-origen-alerta-compacta {
  font-size: 11px;
  line-height: 1.25;
}
.mapa-sin-coords-alerta {
  max-width: 100%;
}
.mapa-sin-coords-select {
  display: block !important;
  flex: 0 0 360px;
  width: 360px;
  max-width: 360px !important;
}
.mapa-sin-coords-select >>> .v-input__control {
  max-width: 360px;
}
.mapa-leyenda {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 7px 9px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.25);
  color: #37474f;
  font-size: 12px;
  pointer-events: none;
}
.mapa-leyenda-punto {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 3px;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);
}
.mapa-leyenda-punto--inbi {
  background: #1565c0;
}
.mapa-leyenda-punto--fast {
  background: #ef6c00;
}
.mapa-leyenda-punto--teacher {
  background: #5e35b1;
}
.mapa-leyenda-punto--custom {
  background: #00897b;
}
.mapa-leyenda-punto--origen {
  background: #2e7d32;
}
.mapa-sucursal-info {
  min-width: 190px;
  max-width: 260px;
  padding: 4px 2px;
  color: #263238;
}
.mapa-sucursal-info__nombre {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
}
.mapa-sucursal-info__escuela {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 7px;
  border-radius: 10px;
  background: #1976d2;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}
.mapa-sucursal-info__direccion {
  margin-top: 6px;
  color: #607d8b;
  font-size: 12px;
  line-height: 1.35;
}
.mapa-kpi-error {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
  color: #e65100;
  background: #fff8e1;
}
.mapa-ruta-embed-wrap {
  border-top: 1px solid #eee;
  padding-top: 8px;
}
.mapa-ruta-modos >>> .v-btn {
  min-width: 72px !important;
}
.ruta-transit-detalle {
  padding: 8px 10px;
  border-left: 3px solid #ef6c00;
  background: #fff8e1;
}
.ruta-transit-paso {
  margin-bottom: 4px;
  line-height: 1.35;
}
.asistente-chat {
  max-height: 240px;
  overflow-y: auto;
}
.asistente-burbuja {
  padding: 8px 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  font-size: 13px;
  white-space: pre-wrap;
}
.asistente-burbuja--user {
  background: #e3f2fd;
  margin-left: 24px;
}
.asistente-burbuja--ia {
  background: #f5f5f5;
  margin-right: 24px;
}
</style>
